import { render, staticRenderFns } from "./Showacthistory.vue?vue&type=template&id=b6a501a8&scoped=true&"
import script from "./Showacthistory.vue?vue&type=script&lang=js&"
export * from "./Showacthistory.vue?vue&type=script&lang=js&"
import style0 from "./Showacthistory.vue?vue&type=style&index=0&id=b6a501a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a501a8",
  null
  
)

export default component.exports